<custom-modal-card
  *ngIf="{
    thematics: thematics$ | async,
    badges: badges$ | async,
    persons: persons$ | async,
    genres: genres$ | async,
    violations: violations$ | async
  } as STATE"
  class="mat-dialog-transparent"
>
  <ng-container header>
    <default-modal-header
      [title]="modalTitle"
      [description]="modalDescription"
    ></default-modal-header>
  </ng-container>
  <ng-container body>
    <form [formGroup]="form" class="resource-form">
      <article>
        <file-tab [tabs]="fileTabs" [defaultTab]="selectedFileTab">
          <file-upload
            (fileChange)="setFile('thumbnail', $event)"
            [preloadedFiles]="program?.thumbnail ? [program!.thumbnail!] : []"
            [label]="'Sélectionnez une vignette (format 3/4).'"
            [accept]="supportedImageExtensions"
            [maxSize]="2_388_608"
          ></file-upload>

          <file-upload
            (fileChange)="setFile('logo', $event)"
            [preloadedFiles]="program?.logo ? [program!.logo] : []"
            [label]="'Faites glisser le logo ici.'"
            [accept]="supportedImageExtensions"
            [maxSize]="2_388_608"
          ></file-upload>
        </file-tab>
        <mat-error *ngIf="logoControl?.getError('httpError') as httpError">
          <strong>Logo: {{ httpError }}</strong>
        </mat-error>
        <mat-error *ngIf="thumbnailControl?.getError('httpError') as httpError">
          <strong>Vignette: {{ httpError }}</strong>
        </mat-error>
      </article>

      <article>
        <mat-label>Intitulé du programme *</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            formControlName="name"
            matInput
            placeholder="Entrez l'intitulé du programme"
          />
        </mat-form-field>
        <mat-error *ngIf="form.get('name')?.getError('httpError') as httpError">
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Description du programme *</mat-label>
        <mat-form-field>
          <textarea
            formControlName="description"
            matInput
            rows="5"
            placeholder="Entrez la description à afficher"
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('description')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article *ngIf="program">
        <mat-label>Intitulé de la période de diffusion</mat-label>
        <mat-form-field>
          <textarea
            formControlName="broadcastPeriodLabel"
            matInput
            rows="3"
            placeholder="Entrez l'intitulé de la période de diffusion à afficher"
          ></textarea>
        </mat-form-field>
        <mat-error
          *ngIf="
            form.get('broadcastPeriodLabel')?.getError('httpError') as httpError
          "
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Thématique *</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="thematicId">
            <mat-option
              *ngFor="let thematic of STATE.thematics"
              [value]="thematic.id"
            >
              {{ thematic.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('thematic')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <!-- <article>
        <mat-label>Catégorie *</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="categoryId">
            <mat-option
              *ngFor="let category of STATE.categories"
              [value]="category.id"
            >
              {{ category.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('category')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article> -->
      <article>
        <mat-label>Badges</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="badgeIds" [multiple]="true">
            <mat-option *ngFor="let badge of STATE.badges" [value]="badge.id">
              {{ badge.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('badges')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Personnes</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="personIds" [multiple]="true">
            <mat-option
              *ngFor="let person of STATE.persons"
              [value]="person.id"
            >
              {{ person.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('personIds')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Genres</mat-label>
        <mat-form-field>
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <mat-select formControlName="genreIds" [multiple]="true">
            <mat-option *ngFor="let genre of STATE.genres" [value]="genre.id">
              {{ genre.name }}
            </mat-option>
          </mat-select>
          <div matSuffix class="custom-suffix">
            <img src="assets/icons/unfold-more.svg" alt="" />
          </div>
        </mat-form-field>
        <mat-error
          *ngIf="form.get('genreIds')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
      <article>
        <mat-label>Limite d'âge</mat-label>
        <mat-form-field color="primary">
          <div matPrefix class="custom-prefix">
            <img src="assets/icons/tag-grey.svg" alt="" />
          </div>
          <input
            formControlName="ageRating"
            matInput
            mask="0*"
            type="number"
            min="0"
            placeholder="Entrez la limite d'age du programme"
          />
        </mat-form-field>
        <mat-error *ngIf="form.get('ageRating')?.hasError('pattern')">
          Veuillez entrer un nombre positif (ex. 1, 12, 99).
        </mat-error>
        <mat-error
          *ngIf="form.get('ageRating')?.getError('httpError') as httpError"
        >
          <strong>{{ httpError }}</strong>
        </mat-error>
      </article>
    </form>
  </ng-container>
  <footer footer class="resource-form">
    <button
      (click)="save()"
      [attr.loading]="isLoading"
      [disabled]="!isFormValid || isLoading"
      class="btn btn--primary-light btn--full"
    >
      {{ program ? 'Mettre à jour les informations' : 'Créer le programme' }}
    </button>
  </footer>
</custom-modal-card>
